import React, { FC, useRef } from 'react'
import {
  Banner,
  Button,
  ModalActions,
  ModalContent,
} from '@lightspeed/design-system-react'
import {
  PaymentMethodForm,
  PaymentMethodFormRef,
} from '@vend/business-components/dist/components/LspayCnp/index'
import { useT } from '@transifex/react'
import { usePaymentFormSubmission } from '../../hooks/usePaymentFormSubmission'
import { PAYMENT_METHOD_ON_FILE_INFO_TERMS_TEXT } from '../../../../../constants/payment-method-on-file-terms'

type Props = {
  session: string
  onVerifyingPaymentMethodStateChange: (isSubmitting: boolean) => void
  onClose: () => void
  onComplete: () => void
  onError: (message: string) => void
  isMotoWithSavePayment: boolean
}

export const LSPAYCnpPmofPaymentForm: FC<Props> = ({
  session,
  onVerifyingPaymentMethodStateChange,
  onComplete,
  onClose,
  onError,
  isMotoWithSavePayment,
}) => {
  const paymentFormRef = useRef<PaymentMethodFormRef>(null)
  const t = useT()

  const {
    isSubmitting,
    bannerErrorMessage,
    handleProcess,
  } = usePaymentFormSubmission({
    onVerifyingPaymentMethodStateChange,
    onComplete,
    onError,
  })

  return (
    <>
      {bannerErrorMessage && (
        <Banner variant="negative">{bannerErrorMessage}</Banner>
      )}
      <ModalContent>
        <PaymentMethodForm ref={paymentFormRef} session={session} />
        {isMotoWithSavePayment && (
          <div className="vd-pb3" data-testid="payment-method-on-file-terms">
            <p className="vd-text--body vd-mb3">
              {t(PAYMENT_METHOD_ON_FILE_INFO_TERMS_TEXT, {
                _context:
                  'Terms of service information text for Payment Method on File feature',
              })}
            </p>
          </div>
        )}
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button
            data-track="add-payment-method-cancel"
            variant="supplementary"
            onClick={onClose}
            disabled={isSubmitting}
          >
            {t('Cancel')}
          </Button>
          <Button
            data-track="add-payment-method-submit"
            variant="go"
            onClick={() => handleProcess(paymentFormRef)}
            loading={isSubmitting}
            disabled={!session || isSubmitting}
          >
            {t('Process')}
          </Button>
        </div>
      </ModalActions>
    </>
  )
}
